import script from "./formPenilaianAspek.vue?vue&type=script&setup=true&lang=js"
export * from "./formPenilaianAspek.vue?vue&type=script&setup=true&lang=js"

import "./formPenilaianAspek.vue?vue&type=style&index=0&id=765359c8&lang=css"

const __exports__ = script;

export default __exports__